






































import Vue from 'vue';
import moment from 'moment';

import api from '../../../api';
import { IShowGenreObject } from '../../../../../shared/types';

interface IData {
  genres: IShowGenreObject[];
}

interface IMethods {
  clicked: () => void;
}

interface IComputed {
  releaseDateFormated: string;
}

interface IProps {
  id: number;
  name: string;
  image: string;
  releaseDate: number;
  overview: string;
}

export default Vue.extend<IData, IMethods, IComputed, IProps>({
  name: 'MovieFeature',

  props: {
    id: {
      type: Number,
      required: true,
    },

    name: {
      type: String,
      required: true,
    },

    image: {
      type: String,
      required: true,
    },

    releaseDate: {
      type: Number,
      required: true,
    },

    overview: {
      type: String,
      required: true,
    },
  },

  methods: {
    clicked() {
      this.$router.push(`/show/${this.name}`);
    },
  },

  data: () => ({
    genres: [] as IShowGenreObject[],
  }),

  async created() {
    this.genres = await api.show.getShowGenres(this.id);
  },

  computed: {
    releaseDateFormated() {
      return moment(this.releaseDate).format('MMMM Do YYYY');
    },
  },
});
